import { CodeSecurityIssueConfidence } from "@oneleet/api_client";

export const CONFIDENCE_LEVEL_MAP: Record<CodeSecurityIssueConfidence, string> =
  {
    [CodeSecurityIssueConfidence.HIGH]: "High",
    [CodeSecurityIssueConfidence.MEDIUM]: "Medium",
    [CodeSecurityIssueConfidence.LOW]: "Low",
  };
